var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 25.928C28.0097 27.7522 26.5386 29.2376 24.7154 29.2474C24.5799 29.2485 24.4433 29.2408 24.3088 29.2244C22.6169 28.9742 21.3774 27.5019 21.419 25.7925V6.1383C21.3785 4.42667 22.6213 2.95442 24.3143 2.70631C26.1254 2.49427 27.766 3.79055 27.978 5.60164C27.9933 5.73498 28.001 5.86833 27.9999 6.00277V25.928Z",
    fill: "#F9AB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.291 22.6699C9.10864 22.6699 10.582 24.1433 10.582 25.9609C10.582 27.7786 9.10864 29.2519 7.291 29.2519C5.47335 29.2519 4 27.7786 4 25.9609C4 24.1433 5.47335 22.6699 7.291 22.6699ZM15.9497 12.6964C14.1233 12.797 12.7068 14.3282 12.7494 16.1568V24.9958C12.7494 27.3949 13.8052 28.8508 15.3518 29.1612C17.1367 29.523 18.8756 28.3699 19.2374 26.585C19.2822 26.3664 19.3041 26.1446 19.303 25.9216V16.0038C19.3062 14.1796 17.8307 12.6986 16.0065 12.6953C15.9879 12.6953 15.9682 12.6953 15.9497 12.6964Z",
    fill: "#E37400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalytics);
export default __webpack_public_path__ + "static/media/GoogleAnalytics.800f46f16a071d539503cbe854bbc4ca.svg";
export { ForwardRef as ReactComponent };